var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oisi69cmta"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 1",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#a7abc3"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 2",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#6c7293"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 1",
    style: {
      clipPath: "url(#oisi69cmta)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 29",
    d: "M11.426 11.591a3.754 3.754 0 0 0 3.713-3.8 3.714 3.714 0 1 0-7.426 0 3.754 3.754 0 0 0 3.713 3.8m0 1.9C8.947 13.489 3 14.76 3 17.284v.949c0 .522.418 4.776.928 4.776h15c.511 0 .928-4.254.928-4.776v-.949c0-2.524-5.947-3.8-8.426-3.8",
    transform: "translate(-1.426 -1)",
    style: {
      fill: "#a7abc3"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.1a8bf30e67b0cacc06cc0ab2b85799c9.svg";
export { ForwardRef as ReactComponent };